// Tappay Configuration
// 注意：這些是公開的配置，敏感資訊應該在後端處理

export const TAPPAY_CONFIG = {
  // 前端配置 (公開資訊)
  APP_ID: process.env.VUE_APP_TAPPAY_APP_ID,
  APP_KEY: process.env.VUE_APP_TAPPAY_APP_KEY,
  ENV: process.env.VUE_APP_TAPPAY_ENV,
  
  // Apple Pay 配置
  APPLE_PAY_MERCHANT_ID: process.env.VUE_APP_TAPPAY_APPLE_PAY_MERCHANT_ID,
  APPLE_PAY_DOMAIN: process.env.VUE_APP_TAPPAY_APPLE_PAY_DOMAIN,
  
  // Line Pay 配置
  LINE_PAY_CHANNEL_ID: process.env.VUE_APP_TAPPAY_LINE_PAY_CHANNEL_ID,
  
  // API 端點
  API_ENDPOINTS: {
    SANDBOX: 'https://sandbox.tappaysdk.com',
    PRODUCTION: 'https://prod.tappaysdk.com'
  }
}

// 測試卡號
export const TEST_CARDS = {
  VISA: '4242 4242 4242 4242',
  MASTERCARD: '5555 5555 5555 4444',
  JCB: '3566 0020 2036 0505'
}

// 安全說明
export const SECURITY_NOTES = {
  FRONTEND_SAFE: [
    'APP_ID - 公開資訊，可安全暴露',
    'APP_KEY - 公開資訊，用於前端 SDK 初始化'
  ],
  BACKEND_ONLY: [
    'MERCHANT_ID - 敏感資訊，僅後端使用',
    'PARTNER_KEY - 敏感資訊，用於 API 簽名',
    'SECRET_KEY - 最敏感資訊，用於加密'
  ]
} 